import { Widget, WidgetHeader, WidgetBody } from "../../../ui/Widget"
import { useEffect, useState } from "react"
import useStore from "../../../../store"
import FieldAuditUnitRow from "./FieldAuditUnitRow"
import UnitPhotoPreview from "./UnitPhotoPreview"
import SearchBar from "../../../common/SearchBar"
import unitFilter from "../../../../utilities/unitFilter"
import { AccordionRoot } from "../../../ui/accordion"

export default function FieldAuditUnits({ fieldAuditId }) {
  const { fetchFieldAuditUnits, fieldAuditUnits, requestQueue, fetchUnitFiles } = useStore()

  const [fetchingFieldAuditUnits, setFetchingFieldAuditUnits] = useState(true)
  const [searchBarValue, setSearchBarValue] = useState('')
  const [filteredFieldAuditUnits, setFilteredFieldAuditUnits] = useState(fieldAuditUnits.data)
  const [openUnitId, setOpenUnitId] = useState([])
  const [photoPreviewUnitId, setPhotoPreviewUnitId] = useState(null)

  const isUnitsForCurrentAudit = Number(fieldAuditUnits?.['field_audit_id']) === Number(fieldAuditId)

  useEffect(() => {
    fetchFieldAuditUnits(fieldAuditId,
      () => setFetchingFieldAuditUnits(false)
    )
  }, [])

  useEffect(() => {
    if (fieldAuditUnits?.data && isUnitsForCurrentAudit) {
      setFilteredFieldAuditUnits(unitFilter(fieldAuditUnits?.data.filter(unit => !requestQueue.some(request => request.meta.auditUnitId === unit.id)), searchBarValue, true))
    } else {
      setFilteredFieldAuditUnits([])
    }
  }, [searchBarValue, fieldAuditUnits, requestQueue, isUnitsForCurrentAudit])

  const handleRowClick = (id) => {
    if (openUnitId.includes(id)) {
      setOpenUnitId([])
    } else {
      setOpenUnitId([id])
    }
  }

  const handleViewPhotos = (unitId) => {
    setPhotoPreviewUnitId(unitId)
    fetchUnitFiles(unitId, { photo: true, perPage: 6 })
  }

  return(
    <Widget>
      <WidgetHeader title="Field Audit Units" showSpinner={fetchingFieldAuditUnits}>
        <SearchBar
          onChange={setSearchBarValue}
          value={searchBarValue}
          handleReset={() => setSearchBarValue('')}
        />
      </WidgetHeader>
      <WidgetBody
        isVisible={!fetchingFieldAuditUnits || isUnitsForCurrentAudit}
      >
        {fieldAuditUnits?.data?.length > 0 && filteredFieldAuditUnits?.length > 0 ?
          <AccordionRoot
            collapsible
            lazyMount
            unmountOnExit
            value={openUnitId}
            onValueChange={(e) => setOpenUnitId(e.value)}
          >
            {filteredFieldAuditUnits.map((fieldAuditUnit) => (
              <FieldAuditUnitRow
                key={fieldAuditUnit.id}
                fieldAuditUnit={fieldAuditUnit}
                fieldAuditId={fieldAuditId}
                handleClick={handleRowClick}
                filter={searchBarValue}
                onViewPhotos={handleViewPhotos}
              />
            ))}
          </AccordionRoot>
        :
          <div className="text-center text-fpx-red mb-2">
            No Units to Audit
          </div>
        }
      </WidgetBody>
      <UnitPhotoPreview isOpen={!!photoPreviewUnitId} onClose={() => setPhotoPreviewUnitId(null)} unitId={photoPreviewUnitId} />
    </Widget>
  )
}